<template>
  <div>
    <auth-modal
      v-if="!passwordResetted"
      :backLinkText="backLinkText"
      backlink="login"
    >
      <template v-slot:title>
        <h1>{{ $t("auth-reset-password") }}</h1>
      </template>
      <template v-slot:content>
        <p>
          {{ $t("auth-change-password-description", { email: userEmail }) }}
        </p>
      </template>
      <template v-slot:footer-content>
        <form>
          <fieldset>
            <div class="form-group">
              <label>
                {{ $t("auth-new-password") }}
                <input
                  type="password"
                  name="password"
                  v-model.trim="password"
                  autocomplete="new-password"
                  :placeholder="$t('auth-register-form-password-placeholder')"
                />
              </label>
            </div>
            <div class="form-group">
              <label>
                {{ $t("auth-confirm-new-password") }}
                <input
                  type="password"
                  name="confirmPassword"
                  v-model.trim="confirmPassword"
                  autocomplete="confirm-new-password"
                  :placeholder="$t('auth-register-form-password-placeholder')"
                />
              </label>
              <!-- TODO move meter to separate component as it is used in two places-->
              <div id="meter">
                <div id="password-strength-description">
                  <p>{{ $t("auth-form-register-password-strength-title") }}</p>
                  <p v-if="strength" :class="strength">
                    {{ $t(`auth-form-register-password-strength-${strength}`) }}
                  </p>
                </div>
                <div id="password-strength-meter">
                  <span :data-length="passwordStrengthMeter"></span>
                </div>
              </div>
            </div>
            <div class="form-group flex">
              <button
                type="submit"
                class="primary"
                @click.prevent="changePassword"
                :disabled="
                  !password ||
                    !confirmPassword ||
                    password !== confirmPassword ||
                    passwordStrengthMeter < 1
                "
              >
                {{ $t("auth-update-password") }}
                <plane-icon width="14" height="14"></plane-icon>
              </button>
            </div>
          </fieldset>
        </form>
      </template>
    </auth-modal>
    <auth-modal v-else :btntext="btntext" backlink="login">
      <template v-slot:title>
        <h1>{{ $t("auth-password-changed") }}</h1>
      </template>
      <template v-slot:content>
        <p>{{ $t("auth-password-changed-description") }}</p>
      </template>
    </auth-modal>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import Base from "@/views/modules/base/Index";
import AuthModal from "@/components/AuthModal";
import PlaneIcon from "@/components/icons/PlaneIcon";
import zxcvbn from "zxcvbn";

export default {
  name: "ChangePassword",
  extends: Base,
  components: {
    AuthModal,
    PlaneIcon
  },
  data() {
    return {
      password: "",
      confirmPassword: "",
      passwordResetted: false
    };
  },
  computed: {
    backLinkText() {
      return this.$t("auth-verification-modal-back");
    },
    btntext() {
      return this.$t("auth-back-to-login");
    },
    userEmail() {
      return (this.$route.query && this.$route.query.user) || "";
    },
    // TODO move this to separate file, as this is copy paste from register form
    passwordStrengthMeter() {
      const strength = zxcvbn(this.password);
      return strength.score;
    },
    strength() {
      let strength = "";
      switch (this.passwordStrengthMeter) {
        case 1:
          strength = "weak";
          break;
        case 2:
          strength = "medium";
          break;
        case 3:
          strength = "strong";
          break;
        case 4:
          strength = "strong";
          break;
      }
      return strength;
    }
  },
  methods: {
    ...mapActions("common", ["setLoading", "showModal"]),
    changePassword() {
      this.setLoading(true);
      const data = {
        token: this.$route.query && this.$route.query.token,
        password: this.password
      };
      this.$store
        .dispatch("auth/changePassword", data)
        .then(res => {
          this.setLoading(false);
          if (res && res.status === 200) {
            this.passwordResetted = true;
          }
        })
        .catch(err => {
          this.passwordResetted = false;
          this.setLoading(false);
          this.showModal({
            title: err.errorCode
          });
          this.resetForm();
        });
    },
    resetForm() {
      this.email = "";
    }
  }
};
</script>

<style lang="scss" scoped>
@import "../../../../assets/styles/variables";
form {
  width: 100%;
  .form-group {
    justify-content: flex-end;
  }
  button {
    svg {
      margin-right: 0;
      margin-left: 5px;
    }
  }
}
#meter {
  margin: 10px 0;
}
#password-strength-description {
  display: flex;
  justify-content: space-between;
  > p {
    margin: 0;
    padding: 5px 0;
    color: $placeholder-color;
    &.weak {
      color: $error-color;
    }
    &.medium {
      color: $warning-color;
    }
    &.strong {
      color: $success-color;
    }
  }
}
#password-strength-meter {
  width: 100%;
  height: 12px;
  border-radius: $radius;
  background-color: $middle-gray;
  > span {
    transition: width 0.5s;
    display: block;
    height: 100%;
    border-radius: $radius;
    width: 0;
    &[data-length="1"] {
      width: 33%;
      background-color: $error-color;
    }
    &[data-length="2"] {
      width: 66%;
      background-color: $warning-color;
    }
    &[data-length="3"] {
      width: 100%;
      background-color: $success-color;
    }
    &[data-length="4"] {
      width: 100%;
      background-color: $success-color;
    }
  }
}
</style>
